import { useRef as R, useState as _, useMemo as p, useEffect as j, useCallback as l } from "react";
import { _ as k } from "../../../libServer-MKeVPlN9.js";
const x = 111320;
function z({
  initialSingleMarker: c,
  randomPosition: o = !1,
  id: M = "1",
  onMoveEnd: s,
  onDragEnd: g,
  onResize: L,
  ref: u,
  debounceEventsTime: a = 300
}) {
  const n = R(null), [m, y] = _(!1), f = R(null), h = p(() => {
    if (!o) return null;
    const t = M.toString();
    let e = 0;
    for (let r = 0; r < t.length; r++)
      e = (e << 5) - e + t.charCodeAt(r), e = e & e;
    return () => {
      const r = Math.sin(e++) * 1e4;
      return r - Math.floor(r);
    };
  }, [o, M]), A = p(() => {
    if (!c) return null;
    if (!o || !h) return c;
    const t = { ...c }, e = h, r = e() * 2 * Math.PI, I = e() * 500, G = I / x * Math.cos(r), O = I / (x * Math.cos(t.latitude * Math.PI / 180)) * Math.sin(r);
    return t.latitude += G, t.longitude += O, t;
  }, [c, o, h]);
  j(() => {
    u && n.current && (typeof u == "function" ? u(n.current) : u.current = n.current);
  }, [u, m]);
  const d = p(() => a <= 0 || !s ? null : k(() => {
    if (f.current) {
      const { event: e, bounds: r } = f.current;
      s(e, r);
    }
  }, a), [a, s]), B = l(
    (t) => {
      a > 0 && d ? (f.current = { event: t, bounds: n.current?.getBounds() }, d()) : s?.(t, n.current?.getBounds());
    },
    [s, a, d]
  ), C = l(
    (t) => {
      g?.(t);
    },
    [g]
  ), D = l(
    (t) => {
      L?.(t);
    },
    [L]
  ), S = l(() => {
    y(!0);
  }, []);
  return {
    mapRef: n,
    mapLoaded: m,
    singleMarker: A,
    handleMoveEnd: B,
    handleDragEnd: C,
    handleResize: D,
    handleMapLoad: S
  };
}
export {
  x as OneDegreeInMeters,
  z as useMap
};
